import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Avatar,
  IconButton,
  TableCell,
} from '@mui/material';
import { useMain } from '../hooks/useMain';
import { CheckCircleRounded, DangerousRounded } from '@mui/icons-material';
import ProfileImg from '../../../src/assets/images/profile/user-1.jpg';

export const TrimData = (data) => {
  if (data?.length < 25) return data;
  return data?.substring(0, 15) + '...' + data?.substring(data?.length - 10);
};

const Users = ({ data,getData }) => {

  const [openDialogue, setOpenDialogue] = useState(false);
  const [id, setId] = useState(null);

  const { updateBranchStatus,setShowMessage } = useMain();

  const handleCloseDialogue = () => {
    setOpenDialogue(false);
    setId(null);
  };

  const handleAction = async (di, id) => {
    const updatedData = {
      status: di === 'Cancel' ? 'CANCELLED BY ADMIN' : 'APPROVED',
    };
    try {
        const res = await updateBranchStatus(updatedData, id);
        if (res?.statusCode === 200) {
            setShowMessage({message:res.message||'Resolved successfully',messageType:'success'})
          getData()
          setId(null);
        } else {
            setShowMessage({message:res.message||'Request not resolved',messageType:'error'})
        }  
    } catch (error) {
        setShowMessage({message:error.message||'Something went wrong',messageType:'error'})
    }finally{
    handleCloseDialogue();
    }
  };

  return (
    <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>
      <table className="table-container mt-3">
        <thead className="table-thead">
          <tr>
            {['Name', 'Email', 'Status', 'Actions'].map((h, index) => {
              return (
                <th key={index} style={{ width: '100%' }}>
                  {h}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody className="table-tbody">
          {data.map((item) => {
            return (
              <tr key={item._id}>
                <td style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <Avatar
                    src={item?.logo ? item?.logo?.url : ProfileImg}
                    alt={item?.logo ? item?.logo?.url : ProfileImg}
                    sx={{
                      width: 30,
                      height: 30,
                    }}
                  />
                  {TrimData(item?.branchName)}
                </td>
                <td style={{ width: '100%' }}>{item?.branchEmail}</td>
                <td style={{ width: '100%' }}>{item?.activeStatus}</td>
                <td style={{ width: '100%' }}>
                    <div>
                      <IconButton
                        aria-controls="dropdown-menu"
                        aria-haspopup="true"
                        onClick={() => {
                          setOpenDialogue('Accept');
                          setId(item?._id);
                        }}
                        size="small"
                      >
                        <CheckCircleRounded sx={{ color: 'green' }} />
                      </IconButton>
                      <IconButton
                        aria-controls="dropdown-menu"
                        aria-haspopup="true"
                        onClick={() => {
                          setOpenDialogue('Cancel');
                          setId(item?._id);
                        }}
                        size="small"
                      >
                        <DangerousRounded sx={{ color: 'red' }} />
                      </IconButton>
                    </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <Dialog open={openDialogue} onClose={handleCloseDialogue}>
        <DialogTitle>Confirm Request</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to {openDialogue} the request?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogue}>Cancel</Button>
          <Button onClick={() => handleAction(openDialogue, id)} autoFocus>
            Sure
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Users;
